import { StateCreator } from 'zustand';

import { StoreInterface } from '@/stores/store';
import { Beneficiary } from '@/typings/beneficiary';
import { User } from '@/typings/user';

export type Entity = keyof Omit<FirebaseSlice, 'updateData'>;

export type FirebaseSlice = {
  users: User[] | null;
  beneficiaries: Beneficiary[] | null;
  updateData: <DataType>(entity: Entity, callback: (state: DataType) => DataType) => void;
};

export const createFirebaseSlice: StateCreator<
  StoreInterface,
  [],
  [],
  FirebaseSlice /* Current slice type */
> = (set, get) => ({
  users: null,
  beneficiaries: null,
  updateData: <DataType>(entity: Entity, callback: (state: DataType) => DataType) => {
    const store = get();
    const data = callback((store[entity] || []) as unknown as DataType);
    set({ ...store, [entity]: data as FirebaseSlice[typeof entity] });
  },
});
